<div class="container single-container">
  <div class="pnf-illu"></div>
  <p class="pnf-copy" translate>page-not-found.message</p>
</div>
